export const daysList = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const dayListOptions = daysList.map((item) => ({
  label: item,
  value: item,
}));

export default daysList;
